var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import AssetServiceEntryRow from './AssetServiceEntryRow';
import ServiceEntryCollection from '../../../../collections/services/ServiceEntryCollection';
import GetOpenAssetServiceEntriesCommand from '../../../../commands/services/GetOpenAssetServiceEntriesCommand';
import GetClosedAssetServiceEntriesCommand from '../../../../commands/services/GetClosedAssetServiceEntriesCommand';
import { ApplicationContext } from '../../../../ApplicationContext';
import CreateManualServiceEntryOverlay from '../../ServiceEntries/CreateManualServiceEntryOverlay';
import Signals from '../../../../signals/Signals';
import ServiceEntryStatus from '../../../../data/ServiceEntryStatus';
import { compareDates, compareNumbers, compareStrings } from '../../../../utils/compareUtils';
import SortModel from "../../../../models/SortModel";
import { ExportButton } from "../../../components/ui/ExportButton/ExportButton";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var AssetServiceEntries = /** @class */ (function (_super) {
    __extends(AssetServiceEntries, _super);
    /**
     *
     * @param props
     */
    function AssetServiceEntries(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            assetServiceEntryCollection: new ServiceEntryCollection(false),
            showClosed: false,
            sort: new SortModel({ fieldName: 'closeDateTimeUtc', direction: -1 })
        };
        _this.onServiceEntryClosed = _this.onServiceEntryClosed.bind(_this);
        _this.onServiceEntryUpdated = _this.onServiceEntryUpdated.bind(_this);
        _this.onServiceEntryAdded = _this.onServiceEntryAdded.bind(_this);
        _this.onNewServiceEntry = _this.onNewServiceEntry.bind(_this);
        _this.applyFilter = _this.applyFilter.bind(_this);
        _this.applySort = _this.applySort.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetServiceEntries.prototype.componentDidMount = function () {
        this.componentInitialize();
        Signals.ServiceEntryClosed.add(this.onServiceEntryClosed);
        Signals.ServiceEntryUpdated.add(this.onServiceEntryUpdated);
        Signals.ServiceEntryAdded.add(this.onServiceEntryAdded);
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    AssetServiceEntries.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.assetModel !== this.props.assetModel) {
            this.componentInitialize();
        }
    };
    /**
     *
     */
    AssetServiceEntries.prototype.componentInitialize = function () {
        var session = this.context.session;
        var assetModel = this.props.assetModel;
        var _a = this.state, assetServiceEntryCollection = _a.assetServiceEntryCollection, showClosed = _a.showClosed, sort = _a.sort;
        var user = session.user;
        if (showClosed) {
            sort.fieldName = 'closeDateTimeUtc';
            sort.direction = -1;
        }
        else {
            sort.fieldName = 'status';
            sort.direction = 1;
        }
        var command = showClosed ? new GetClosedAssetServiceEntriesCommand() : new GetOpenAssetServiceEntriesCommand();
        command.execute(user.organisation, assetModel, assetServiceEntryCollection);
    };
    AssetServiceEntries.prototype.componentWillUnmount = function () {
        Signals.ServiceEntryClosed.remove(this.onServiceEntryClosed);
        Signals.ServiceEntryUpdated.remove(this.onServiceEntryUpdated);
        Signals.ServiceEntryAdded.remove(this.onServiceEntryAdded);
    };
    /**
     *
     * @return {*}
     */
    AssetServiceEntries.prototype.render = function () {
        var _this = this;
        var intl = this.props.intl;
        var assetServiceEntryCollection = this.state.assetServiceEntryCollection;
        return (React.createElement("div", { className: "w-100" },
            React.createElement("div", { className: "d-flex w-100 justify-content-between align-items-center" },
                React.createElement("div", { className: "custom-control custom-switch" },
                    React.createElement("input", { type: "checkbox", className: "custom-control-input", id: "showClosedServiceEntries", onChange: function (event) {
                            _this.setState({ showClosed: event.target.checked }, function () { return _this.componentInitialize(); });
                        } }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "showClosedServiceEntries" }, "Toon gesloten")),
                React.createElement("div", { className: "d-flex" },
                    assetServiceEntryCollection.list.length > 0 &&
                        React.createElement(ExportButton, { disabled: assetServiceEntryCollection.list.length <= 0, onClick: function (event, type) {
                                assetServiceEntryCollection.export(type, intl);
                            } }),
                    React.createElement("button", { className: "btn btn-primary ml-3 mr-2", onClick: this.onNewServiceEntry },
                        React.createElement("span", { className: "fe fe-plus" }),
                        " ",
                        React.createElement(FormattedMessage, { id: "asset.detail.serviceentry.add.new" })))),
            React.createElement("hr", null),
            React.createElement("div", { className: "d-flex flex-wrap w-100" }, this.applySort(assetServiceEntryCollection.list)
                .filter(this.applyFilter)
                .map(function (serviceEntryModel) {
                return React.createElement(AssetServiceEntryRow, { key: serviceEntryModel.serviceEntryId, serviceEntryModel: serviceEntryModel });
            }))));
    };
    /**
     *
     * @param serviceEntryModel
     */
    AssetServiceEntries.prototype.onServiceEntryClosed = function (serviceEntryModel) {
        var assetServiceEntryCollection = this.state.assetServiceEntryCollection;
        assetServiceEntryCollection.remove(serviceEntryModel);
    };
    /**
     *
     * @param serviceEntryModel
     */
    AssetServiceEntries.prototype.onServiceEntryUpdated = function (serviceEntryModel) {
        var assetServiceEntryCollection = this.state.assetServiceEntryCollection;
        var model = assetServiceEntryCollection.find('serviceEntryId', serviceEntryModel.serviceEntryId);
        if (model) {
            model.update(serviceEntryModel);
        }
        this.forceUpdate();
    };
    /**
     *
     */
    AssetServiceEntries.prototype.onServiceEntryAdded = function () {
        this.componentInitialize();
    };
    /**
     *
     */
    AssetServiceEntries.prototype.onNewServiceEntry = function () {
        var _this = this;
        Signals.ShowOverlay.dispatch(React.createElement(CreateManualServiceEntryOverlay, { assetModel: this.props.assetModel, successCallback: function () { return _this.componentInitialize(); } }));
    };
    /**
     *
     * @param serviceEntryModel
     */
    AssetServiceEntries.prototype.applyFilter = function (serviceEntryModel) {
        return serviceEntryModel.status !== ServiceEntryStatus.Closed && !this.state.showClosed || this.state.showClosed;
    };
    /**
     *
     * @param items
     * @return {*}
     */
    AssetServiceEntries.prototype.applySort = function (items) {
        var sort = this.state.sort;
        if (!sort)
            return items;
        var result = items.concat([]);
        result.sort(function (a, b) {
            switch (sort.fieldName) {
                case 'status':
                    return compareNumbers(a.status, b.status) * sort.direction;
                case 'id':
                    return compareNumbers(a.id, b.id) * sort.direction;
                case 'lastModifiedDateTimeUtc':
                    return compareDates(a.lastModifiedDateTimeUtc, b.lastModifiedDateTimeUtc) * sort.direction;
                case 'creationDateTimeUtc':
                    return compareDates(a.creationDateTimeUtc, b.creationDateTimeUtc) * sort.direction;
                case 'dueDateTimeUtc':
                    return compareDates(a.dueDateTimeUtc, b.dueDateTimeUtc) * sort.direction;
                case 'closeDateTimeUtc':
                    return compareDates(a.closeDateTimeUtc, b.closeDateTimeUtc) * sort.direction;
                default:
                    return compareStrings(a[sort.fieldName], b[sort.fieldName]) * sort.direction;
            }
        });
        return result;
    };
    AssetServiceEntries.defaultProps = {
        className: ''
    };
    AssetServiceEntries = __decorate([
        observer
    ], AssetServiceEntries);
    return AssetServiceEntries;
}(React.Component));
AssetServiceEntries.contextType = ApplicationContext;
export default injectIntl(AssetServiceEntries);
